import { TRACKING_WORD_DELIMITER } from "../analytics/constants";
export const formatCategoryBreadcrumbs = breadcrumbs =>
  breadcrumbs
    .slice(1)
    .filter(breadcrumb => breadcrumb.Label !== undefined)
    .map(breadcrumb => breadcrumb.Label)
    .join(TRACKING_WORD_DELIMITER)
    .toLowerCase();
